import { windowWidth } from './dimensions'

export const quarterOfWindowWidth = windowWidth / 4
